import { Star } from "lucide-react";
import { TESTIMONIALS } from "../data/products";
import { useLang } from "../i18n";
import { FadeIn, Micro } from "./Reveal";

function Track() {
  const { t } = useLang();
  const quotes = t("testimonials.quotes");
  const items = TESTIMONIALS.map((x, i) => ({ name: x.name, quote: quotes[i] || x.quote }));
  const set = [...items, ...items, ...items, ...items];
  const half = (key) => (
    <div className="flex shrink-0 items-stretch" key={key}>
      {set.map((t, i) => (
        <figure
          key={`${t.name}-${i}`}
          data-testid={`testimonial-${i}`}
          className="shrink-0 w-[340px] md:w-[520px] mr-6 md:mr-10 border-l border-gold/30 pl-6 md:pl-8 py-2"
        >
          <div className="flex gap-1 text-gold">
            {Array.from({ length: 5 }).map((_, s) => (
              <Star key={s} className="w-3 h-3" fill="currentColor" strokeWidth={0} />
            ))}
          </div>
          <blockquote className="font-display text-lg md:text-2xl leading-snug text-cream/85 mt-4">
            &ldquo;{t.quote}&rdquo;
          </blockquote>
          <figcaption className="mt-4 text-[10px] tracking-[0.3em] uppercase text-cream/40">
            {t.name}
          </figcaption>
        </figure>
      ))}
    </div>
  );
  return (
    <div className="marquee-row overflow-hidden" data-testid="testimonial-marquee">
      <div className="marquee-track" style={{ "--dur": "95s" }}>
        {half("a")}
        {half("b")}
      </div>
    </div>
  );
}

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 border-t border-white/5 overflow-hidden">
      <FadeIn className="px-5 md:px-12 mb-12 flex items-center justify-between">
        <Micro className="text-gold/80">{t("testimonials.chapter")}</Micro>
        <Micro className="hidden md:block">{t("testimonials.note")}</Micro>
      </FadeIn>
      <Track />
    </section>
  );
}
